export interface NamedValue {
  name: string;
  value: string;
}

export enum FilterType {
  Date = 'date',
  Array = 'array',
  Value = 'value',
  Number = 'number',
}

export interface ReportFilter {
  displayName: string;
  options?: NamedValue[];
  type: FilterType;
  min?: string;
  max?: string;
}

export type ReportFilterMap = Record<string, ReportFilter>;

export interface Report {
  rows: string[][];
  headers: NamedValue[];
  sortableHeaders: string[];
  filters: ReportFilterMap;
  page: number;
  hasNextPage: boolean;
}
